import { gql } from '@apollo/client';

const SAVE_ATTEMPT_STUDENT = gql`
  mutation saveAttempt($data: SaveAttemptInput!, $fileUpload: FileUploadInput) {
    saveAttempt(data: $data, fileUpload: $fileUpload) {
      assignmentActivityId
      status
      dateStarted
      dateCompleted
      studentReward {
        reward {
          audio {
            id
            description
            src
          }
          asset {
            captions
            description
            src
          }
        }
      }
    }
  }
`;

const SAVE_ATTEMPT_EDUCATOR = gql`
  mutation saveAttempt($data: SaveAttemptInput!, $fileUpload: FileUploadInput) {
    saveAttempt(data: $data, fileUpload: $fileUpload) {
      assignmentActivityId
      status
      dateStarted
      dateCompleted
    }
  }
`;

export { SAVE_ATTEMPT_STUDENT, SAVE_ATTEMPT_EDUCATOR };
